<div class="holder">
  <h1>UTM Link Raporları ({{ data.length }})</h1>

  <div class="filter">
    <div class="row">
      <div class="form-control-holder">
        <label for="">UTM Link</label>
        <input type="text" [(ngModel)]="utmLink" />
      </div>
      <div
        class="form-control-holder"
        style="padding-top: 15px; padding-left: 15px"
      >
        <app-button text="Raporu Getir" (click)="getReport()"></app-button>
      </div>
    </div>
  </div>

  <br />

  <div class="loader-container" *ngIf="loading">
    <app-loader></app-loader>
  </div>

  <div *ngIf="isReportReady">
    <div class="excel-download-container">
      <app-button text="Excel İndir" (click)="downloadExcel()"></app-button>
    </div>

    <div class="data-holder">
      <div class="table-holder">
        <table>
          <thead>
            <tr>
              <th>Telefon No</th>
              <th>Anket Adı</th>
              <th>Tarih</th>
              <th>UTM Link</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of data">
              <td>{{ item.phoneNumber }}</td>
              <td>{{ item.surveyName }}</td>
              <td>{{ item.createdOn | date : "dd.MM.YYYY HH:mm" }}</td>
              <td>{{ item.utmLink }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
